import { Button } from '../../../../components/ui/button'
import { Modal } from '../../../../components/ui/modal'
import { Select } from '../../../../components/ui/select'
import { Input } from '../../../../components/ui/input'
import { Column } from '../../../../components/layouts/columns'
// import { Table } from '../../../../components/ui/table'
// import { Image } from '../../../../components/ui/image'
import { DataComTraçoParaDataComBarra } from '../../../../utils/dates'
import { Icon } from '../../../../components/icons'
import { Table } from '../../../../components/ui/table'
import { Form } from '../../../../components/ui/form'
import { PathDoc } from '../../../../router/docs'
export const ModalAddCandidates = ({
  active = true,
  setActive,
  formContext,
  dataContext,
  setFormContext,
  infosContext,
  setSearch,
  search,
  actions = {
    searchFavorite: () => {},
    add: () => {},
  },
  loading,
}) => {
  if (active) {
    return (
      <Modal.Root active={active}>
        <Modal.Contents witdh={720}>
          <Modal.Header title={'Adicionar Colaborador ao Evento'}>
            <Button.Content>
              <Button.A className={'mr-4'} link={PathDoc.EventFinally} openNew color="is-light" loading={loading}>
                Tutorial
              </Button.A>
            </Button.Content>
            <Modal.HeaderClose setActive={setActive}></Modal.HeaderClose>
          </Modal.Header>

          {(infosContext?.filters?.dates || []).length > 0 ? (
            <>
              <Modal.Body>
                <Column.Root>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label
                        className="ml-3 has-text-grey-light is-size-7"
                        style={{ marginBottom: 0 }}
                        required={true}
                      >
                        Vaga
                      </Input.Label>
                      <Select.Root>
                        <Select.Search
                          value={formContext}
                          setValue={setFormContext}
                          field={'jobInvite'}
                          options={infosContext?.ListJobOffers.map((job) => ({
                            value: job.id,
                            label: `${job.positionName} - ${job.round} - ${DataComTraçoParaDataComBarra(job.date)}`,
                          })).sort((a, b) => a.label.localeCompare(b.label))}
                          required
                        ></Select.Search>
                      </Select.Root>
                    </Input.Root>
                  </Column.Content>
                </Column.Root>

                <Column.Root>
                  <Column.Content>
                    <Input.Label
                      className="ml-3 has-text-grey-light is-size-7"
                      style={{ marginBottom: 0 }}
                      required={true}
                    >
                      Lista de Staff
                    </Input.Label>
                    <Form.Root
                      action={() => {
                        actions.searchFavorite()
                      }}
                    >
                      <Input.Root className="mt-2">
                        <Input.Contents alignIcon={'left'}>
                          <Input.Prompt
                            value={search}
                            setValue={setSearch}
                            maskSetValue="cpf"
                            maskValue="cpf"
                            placeholder="Pesquisar por CPF..."
                          ></Input.Prompt>
                          <Input.Icon align="is-left">
                            <Icon size={20}>search</Icon>
                          </Input.Icon>
                        </Input.Contents>
                      </Input.Root>
                    </Form.Root>
                    {!loading ? (
                      dataContext?.favorites?.data.length > 0 ? (
                        <>
                          <Table.Root className="is-fullwidth">
                            <Table.Head>
                              <Table.Row>
                                <Table.Cell></Table.Cell>
                                <Table.Cell className="has-text-centered">Nome</Table.Cell>
                                <Table.Cell className="has-text-centered">CPF</Table.Cell>
                                <Table.Cell className="has-text-centered">Ação</Table.Cell>
                              </Table.Row>
                            </Table.Head>
                            <Table.Body>
                              {dataContext?.favorites?.data.map((colab, index) => {
                                if (colab.status !== 9) {
                                  return (
                                    <Table.Row key={`colabquery${index}`}>
                                      <Table.Cell></Table.Cell>
                                      <Table.Cell className="has-text-centered">
                                        Staff não está ativo no sistema.
                                      </Table.Cell>
                                    </Table.Row>
                                  )
                                }
                                return (
                                  <Table.Row key={`colabquery${index}`}>
                                    <Table.Cell className="is-vcentered">
                                      <figure
                                        style={{
                                          width: '48px',
                                          height: '48px',
                                          marginRight: '12px',
                                          marginTop: '4px',
                                          borderRadius: '50%',
                                          overflow: 'hidden',
                                          backgroundColor: colab.photoUrl ? 'transparent' : '#ccc',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                        }}
                                      >
                                        {colab.photoUrl ? (
                                          <img
                                            src={colab.photoUrl}
                                            alt="photoUrl..."
                                            style={{
                                              width: '100%',
                                              height: '100%',
                                              objectFit: 'cover',
                                              borderRadius: '50%',
                                            }}
                                          />
                                        ) : null}
                                      </figure>
                                    </Table.Cell>
                                    <Table.Cell className="is-vcentered">{colab.name}</Table.Cell>
                                    <Table.Cell className="is-vcentered">{colab.cpf}</Table.Cell>
                                    <Table.Cell className="is-vcentered">
                                      <Button.Bt
                                        color="is-success"
                                        size={'is-small'}
                                        colorText={'has-text-white'}
                                        loading={loading}
                                        action={() => {
                                          actions.add({ ...colab, jobInvite: formContext?.jobInvite })
                                        }}
                                      >
                                        +
                                      </Button.Bt>
                                    </Table.Cell>
                                  </Table.Row>
                                )
                              })}
                            </Table.Body>
                          </Table.Root>
                        </>
                      ) : (
                        <div className="mt-6">
                          <p>Nenhum staff encontrado.</p>
                        </div>
                      )
                    ) : (
                      <div className="mt-5">
                        <Icon className="mt-5">loading</Icon>
                      </div>
                    )}
                  </Column.Content>
                </Column.Root>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </>
          ) : (
            <Modal.Body>
              <article className="message is-danger">
                <div className="message-body">
                  Este eventos não possui <strong>vagas criadas</strong>, para continuar, crie algumas vagas
                </div>
              </article>
            </Modal.Body>
          )}
        </Modal.Contents>
      </Modal.Root>
    )
  } else {
    return <></>
  }
}
